import { useMemo } from 'react';

export function useIsLocalDev() {
  return useMemo(() => window.location.host.includes('localhost'), []);
}
